/*
 * 固定弹窗
 */
import { BaseAction, Query } from "@al/aku-lc-core";

export type SameModalActionPayload = {
  modal: string;
};

export default class SameModalAction extends BaseAction<SameModalActionPayload> {
  execute = async (): Promise<void> => {
    const query = new Query(this.payload?.modal);
    query?.get()?.setBools({
      key: "_visible",
      value: true,
    });
    this.executeAfterActions();
  };
}
